import axios from "axios";
import API_BASE_URL from "../config/api";

const BASE_URL = API_BASE_URL;

// Get all cement testing test requests (for dashboard)
export const getAllCementTestingTestRequests = async () => {
  const url = `${BASE_URL}/cement-testing/test-requests`;
  try {
    console.log('🔵 [CEMENT TESTING API] Fetching all test requests for dashboard');
    console.log('🌐 [CEMENT TESTING API] Full URL:', url);
    const response = await axios.get(url);
    console.log('✅ [CEMENT TESTING API] All test requests fetched successfully:', response.data);
    return response.data.test_requests || [];
  } catch (error) {
    const errorStatus = error.response?.status;
    const errorMessage = error.message || 'Unknown error';
    const errorData = error.response?.data;
    
    console.error("❌ [CEMENT TESTING API] Error fetching all test requests");
    console.error("   Status:", errorStatus);
    console.error("   Message:", errorMessage);
    console.error("   URL:", url);
    console.error("   Response data:", errorData);
    
    if (errorStatus === 404) {
      console.warn("⚠️ [CEMENT TESTING API] Endpoint not found (404). The backend route may not be deployed.");
      console.warn("   Expected endpoint: GET /api/cement-testing/test-requests");
      console.warn("   Please ensure the backend is deployed with the latest code from backend/cement_testing_routes.py");
    }
    
    // Return empty array on error to not break dashboard
    return [];
  }
};

